import Highcharts from 'highcharts/highstock';
import { toMerged } from 'es-toolkit/object';
import { font } from '@op/opds.tokens';

import { formatNumberWithoutDecimals } from '../utils';

const defaultStyle: Partial<Highcharts.CSSObject> = {
  fontFamily: font.stack.default,
  fontSize: font.size.body.small,
};

const defaultChartOptions: Partial<Highcharts.Options> = {
  title: {
    text: undefined,
    align: 'center',
    style: {
      ...defaultStyle,
      ...{
        lineHeight: 1.33,
      },
    },
  },
  navigator: {
    enabled: false,
  },
  credits: { enabled: false },
  yAxis: {
    title: { text: undefined },
    labels: {
      style: {
        ...defaultStyle,
        fontSize: font.size.body.xs,
      },
      formatter: (label: Highcharts.AxisLabelsFormatterContextObject) => {
        return `${formatNumberWithoutDecimals(Number(label.value) ? Number(label.value) : 0)} €`;
      },
    },
  },
  xAxis: {
    labels: {
      style: {
        ...defaultStyle,
        fontSize: font.size.body.xs,
      },
    },
  },
  legend: {
    enabled: false,
    itemStyle: {
      fontFamily: defaultStyle.fontFamily,
      fontSize: font.size.body.small,
    },
  },
  tooltip: {
    enabled: false,
    style: {
      fontFamily: defaultStyle.fontFamily,
      fontSize: font.size.body.small,
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 500,
        },
        chartOptions: {
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom',
          },
        },
      },
    ],
  },
};

export const getChartOptionsWithOverrides = (
  overrides: Partial<Highcharts.Options>,
): Highcharts.Options => {
  return toMerged(defaultChartOptions, overrides);
};

export default defaultChartOptions;
